import { render, staticRenderFns } from "./CandidateUploadLink.vue?vue&type=template&id=0095496d"
import script from "./CandidateUploadLink.vue?vue&type=script&lang=js"
export * from "./CandidateUploadLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0095496d')) {
      api.createRecord('0095496d', component.options)
    } else {
      api.reload('0095496d', component.options)
    }
    module.hot.accept("./CandidateUploadLink.vue?vue&type=template&id=0095496d", function () {
      api.rerender('0095496d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/CandidateUploadLink.vue"
export default component.exports